export const ID = 'id';
export const ACTIVITY = 'activityTypeId';
export const METRIC = 'metricId';
export const TRAFFIC = 'trafficTypeId';
export const GENRES = 'genreIds';
export const APPLICATIONS = 'appIds';
export const NETWORKS = 'netIds';
export const PLATFORMS = 'platformIds';
export const COUNTRIES = 'countryIds';
export const REGISTRATIONS = 'botRegistrationType';
export const SAME_AS_FIRST = 'sameAsFirst';
export const FRAUD = 'fraudType';

export const DEPENDENCIES = {
  [TRAFFIC]: [METRIC],
  [APPLICATIONS]: [GENRES],
  [NETWORKS]: [APPLICATIONS],
  [PLATFORMS]: [NETWORKS, APPLICATIONS],
  [REGISTRATIONS]: [METRIC],
  [FRAUD]: [METRIC],
};
